export default __webpack_public_path__ + "static/media/case-summaries.a8469726.png";